import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';

export const FETCH_TIME_TRACKING_OPTIONS =
	'state.actions.time-tracking-options.FETCH_TIME_TRACKING_OPTIONS';

export type FetchTimeTrackingOptions = {
	type: typeof FETCH_TIME_TRACKING_OPTIONS;
};

export const fetchTimeTrackingOptions = (): FetchTimeTrackingOptions => ({
	type: FETCH_TIME_TRACKING_OPTIONS,
});

export const FETCH_TIME_TRACKING_OPTIONS_SUCCESS =
	'state.actions.time-tracking-options.FETCH_TIME_TRACKING_OPTIONS_SUCCESS';

export type FetchTimeTrackingOptionsSuccess = {
	type: typeof FETCH_TIME_TRACKING_OPTIONS_SUCCESS;
	readonly payload: TimeTrackingOptions;
};

export const fetchTimeTrackingOptionsSuccess = (
	payload: TimeTrackingOptions,
): FetchTimeTrackingOptionsSuccess => ({
	type: FETCH_TIME_TRACKING_OPTIONS_SUCCESS,
	payload,
});

export type Action = FetchTimeTrackingOptions | FetchTimeTrackingOptionsSuccess;
